/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const RESALE_ACTIVE_BOX = gql`
  mutation ResaleActiveBox(
    $filter: UniqBoxFilterInput!
    $reason: String!
    $deleteIfFullyPaid: Boolean
    $deleteReferral: Boolean
    $data: ResaleCostumeInput!
  ) {
    resaleActiveBox(
      filter: $filter
      reason: $reason
      deleteIfFullyPaid: $deleteIfFullyPaid
      deleteReferral: $deleteReferral
      data: $data
    ) {
      _id
      costumeID
      totalAmount
      amountPaid
      isActive
      paymentStats
      boxStatus

      section {
        _id
        name
      }

      user {
        _id
        email
        firstName
        lastName
        vuid
      }

      payOrder {
        paymentStatus
        totalAmount
        remainingAmount
        amountPaid
      }

      items {
        costumeType {
          name
        }
        costumeFeature {
          name
        }
        costumeAttribute {
          name
        }
        costumeValue {
          name
        }
        isPaid
        paidAmount
        paymentStatus
      }

      createdAt
    }
  }
`;
